<template>
    <component
        :is="dynamicComponent"
        v-if="dynamicComponent"
        v-bind="dynamicProps"
        v-on="dynamicHandlers"
        @close="clearDynamicComponent"
    />
</template>

<script setup lang="ts">
import useDynamicComponentLoader from '@/dynamic-component-loader/dynamicComponent.service'

const {dynamicComponent, dynamicProps, dynamicHandlers, clearDynamicComponent} = useDynamicComponentLoader()

</script>

<style scoped>

</style>